import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateSharingSchedule } from "./updateSharingSchedule.request";

const useUpdateSharingSchedule = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateSharingSchedule,
    ...options
  });
};

export default useUpdateSharingSchedule;
